/**
@format
@flow
*/
/**
 * Helper function to that returns group key for reducer
 * GET_PROFILE_API => GET_PROFILE
 */
export default function getActionGroup(type: string): string {
  if (!type) {
    // eslint-disable-next-line no-console
    console.warn('No type passed!');
    return 'GROUP';
  }
  const actionGroupArray: Array<string> = type.split('_');
  actionGroupArray.pop();
  return actionGroupArray.join('_');
}
